import Vue from 'vue';
import Vuex from 'vuex';
import { employee, sideJob, allJob } from '@/store/modules/employee';
import { interview } from '@/store/modules/Interview';
import { news } from '@/store/modules/News';
import { jobOfferType } from '@/types/jobOffer';
import { banner } from '@/store/modules/Banner';

Vue.use(Vuex);

export type RootState = {};

export default new Vuex.Store({
  state: {
    jobOfferCurrentType: jobOfferType.ALLJOB
  },
  modules: {
    employee: employee,
    sideJob: sideJob,
    allJob: allJob,
    interview: interview,
    news: news,
    banner: banner
  }
});
